module.exports = __webpack_public_path__ + "img/30f6.d8a8afe8.jpg";